<template>
  <div>
    <div class="row sticky-button">
      <div class="px-3">
        <div class="form-group has-label">
          <label class="row"
            ><h4 class="d-flex align-self-center">
              {{ $t('sigatoka.plants') }}:
            </h4>
            <strong class="d-flex align-self-center pl-2 pt-3">{{
              model.plants_count
            }}</strong>
          </label>
        </div>
      </div>
    </div>
    <div
      v-for="index in model.plants_count"
      :key="index"
      class="row py-3 mb-4 shadow-sm"
      style="border: 0.5px solid #6ba6524d"
    >
      <div class="row px-3" style="width: 90%">
        <div class="col-12 col-md-2 col-lg-2 col-xl-2">
          <fg-input
            disabled
            class="pl-0"
            type="number"
            v-model="model.plant[index - 1]"
            :label="`${$t('sigatoka.plant')} ${model.plant[index - 1]}: `"
          ></fg-input>
        </div>
        <div class="col-12 col-md-2 col-lg-3 col-xl-2">
          <fg-input
            type="number"
            placeholder="..."
            @keypress="validateInput"
            v-model="model.functional_leaf[index - 1]"
            :class="`pl-0 required-functional_leaf-${index - 1}`"
            :label="`${$t('sigatoka.total_functional_leaves')}: *`"
          ></fg-input>
        </div>
        <div class="col-12 col-md-2 col-lg-3 col-xl-2">
          <fg-input
            type="number"
            placeholder="..."
            @keypress="validateInput"
            v-model="model.yls[index - 1]"
            :label="`${$t('sigatoka.yls')}: *`"
            :class="`pl-0 required-yls-${index - 1}`"
          ></fg-input>
        </div>
        <div class="col-12 col-md-2 col-lg-3 col-xl-2" v-if="model.age == 0">
          <fg-input
            type="number"
            placeholder="..."
            @keypress="validateInput"
            v-model="model.yli[index - 1]"
            :label="`${$t('sigatoka.yli')}: *`"
            :class="`pl-0 required-yli-${index - 1}`"
          ></fg-input>
        </div>
      </div>
      <div class="col-1 col-sm-1 col-lg-1 d-flex align-items-center">
        <div class="btn-group" role="group">
          <button
            class="btn btn-danger custom-shadow-btn mr-2"
            @click.prevent="
              handleDelete(
                index - 1,
                model.functional_leaf[index - 1],
                model.yli[index - 1],
                model.yls[index - 1]
              )
            "
          >
            <em class="fa fa-minus"></em>
          </button>

          <button
            v-if="index === model.plants_count"
            @click.prevent="handlePlus(index - 1)"
            class="btn btn-success custom-shadow-btn"
          >
            <em class="fa fa-plus"></em>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from 'src/i18n';
import { isset } from 'src/util/Util';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MinusPlus from 'src/components/Forms/MinusPlus.vue';
import MixinValidations from 'src/mixins/forms/mixin-validations.js';

export default {
  mixins: [
    MixinForm,
    MixinAlert,
    MixinLoading,
    MixinValidations,
    MixinPermissions,
  ],
  watch: {
    '$i18n.locale': ['getSelectAll'],
  },
  components: {
    [MinusPlus.name]: MinusPlus,
  },
  data() {
    return {
      model: {
        ids: [],
        yls: [],
        yli: [],
        age: null,
        plant: [1],
        deleted_ids: [],
        plants_count: 1,
        key: 'first_step',
        functional_leaf: [],
      },
    };
  },
  methods: {
    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          for (let i = 0; i < this.model.plants_count; i++) {
            if (!isset(this.model.functional_leaf[i]))
              return this.validationInputsRequired(`functional_leaf-${i}`);
            if (!isset(this.model.yli[i]) && this.model.age == 0)
              return this.validationInputsRequired(`yli-${i}`);
            if (!isset(this.model.yls[i]))
              return this.validationInputsRequired(`yls-${i}`);
          }
          this.$emit('on-validated', this.model);

          return isValid;
        }
      });
    },
    handleDelete(index, functional_leaves, yli, yls) {
      if (functional_leaves || yli || yls) {
        SweetAlert.delete(i18n.t('common_words.row')).then((result) => {
          if (result.value) this.handleMinus(index);
        });
      } else {
        this.handleMinus(index);
      }
    },
    handlePlus(index) {
      this.model.plants_count++;
      const i = this.model.plant[index];
      this.model.plant.push(i + 1);
      this.model.ids.push(null);
    },
    handleMinus(index) {
      const minNumber = 1;
      if (this.model.plants_count > minNumber) {
        this.model.plants_count--;
        this.model.yls.splice(index, 1);
        this.model.plant.splice(index, 1);
        this.model.functional_leaf.splice(index, 1);
        if (this.model.ids[index] != null)
          this.model.deleted_ids.push(this.model.ids[index]);
        if (this.model.age == 0) this.model.yli.splice(index, 1);
      } else {
        this.model.plant = [1];
        this.model.ids = [null];
        this.model.yls = [null];
        this.model.plants_count = 1;
        this.model.functional_leaf = [null];
        if (this.model.age == 0) this.model.yli = [null];
      }
    },
    validateInput(event) {
      const input = String.fromCharCode(event.which);
      if (!/[0-9,.]/.test(input)) event.preventDefault();
    },
  },
  created() {
    this.model.plants_count = this.model.plant.length;
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([Axios.getMasters('sigatoka/capture/config')])
        .then(([responseConfig]) => {
          const config = responseConfig.data.data;
          this.model.age = config.sigatoka_config_ages[0].age;
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
};
</script>
